import React from 'react';
import { X, Star, Award, Leaf, Wheat, ThumbsUp, CheckCircle } from 'lucide-react';
import { Modal } from './Modal';

export function BadgeGuide({ isOpen, onClose, t, language }) {
    const badges = [
        {
            id: 'michelin',
            icon: <Star className="text-amber-500" size={24} />,
            title: { en: 'Michelin Guide', th: 'มิชลิน ไกด์' },
            desc: {
                en: 'World-renowned culinary excellence.',
                th: 'ร้านอาหารที่ได้รับการยอมรับในระดับสากล การันตีคุณภาพและความอร่อย'
            },
            color: 'bg-amber-50 border-amber-200'
        },
        {
            id: 'shell_chuan_chim',
            icon: <Award className="text-emerald-600" size={24} />,
            title: { en: 'Shell Chuan Chim', th: 'เชลล์ชวนชิม' },
            desc: {
                en: 'Thailand’s legendary food rating symbol.',
                th: 'สัญลักษณ์ความอร่อยระดับตำนานของไทย รับประกันรสชาติที่ยอดเยี่ยม'
            },
            color: 'bg-emerald-50 border-emerald-200'
        },
        {
            id: 'perp_pitsadarn',
            icon: <ThumbsUp className="text-blue-600" size={24} />,
            title: { en: 'Perp Pitsadarn', th: 'เปิบพิสดาร' },
            desc: {
                en: 'Mae Choy Nang Ram’s certification of deliciousness.',
                th: 'รับประกันความอร่อยโดย แม่ช้อยนางรำ'
            },
            color: 'bg-blue-50 border-blue-200'
        },
        {
            id: 'vegan',
            icon: <Leaf className="text-green-600" size={24} />,
            title: { en: 'Vegan', th: 'อาหารเจ/มังสวิรัติ' },
            desc: {
                en: 'No animal products used.',
                th: 'ไม่มีส่วนผสมของเนื้อสัตว์ นม หรือไข่'
            },
            color: 'bg-green-50 border-green-200'
        },
        {
            id: 'halal',
            icon: <CheckCircle className="text-cyan-600" size={24} />,
            title: { en: 'Halal', th: 'ฮาลาล' },
            desc: {
                en: 'Prepared according to Islamic dietary laws.',
                th: 'ปรุงถูกต้องตามหลักศาสนาอิสลาม'
            },
            color: 'bg-cyan-50 border-cyan-200'
        },
        {
            id: 'glutenFree',
            icon: <Wheat className="text-orange-500" size={24} />, // Wheat crossed out usually, but standard wheat for now
            title: { en: 'Gluten Free', th: 'ปลอดกลูเตน' },
            desc: {
                en: 'Safe for those with gluten intolerance.',
                th: 'ไม่มีส่วนผสมของแป้งสาลี เหมาะสำหรับผู้แพ้กลูเตน'
            },
            color: 'bg-orange-50 border-orange-200'
        }
    ];

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={language === 'th' ? 'ความหมายของสัญลักษณ์' : 'Badge Guide'}
            icon={<Award size={20} />}
            size="md"
        >
            <div className="grid gap-3">
                {badges.map((badge) => (
                    <div
                        key={badge.id}
                        className={`flex items-start gap-4 p-4 rounded-xl border ${badge.color} hover:shadow-sm transition-shadow`}
                    >
                        <div className="shrink-0 p-2 bg-white rounded-full shadow-sm">
                            {badge.icon}
                        </div>
                        <div>
                            <h3 className="font-semibold text-neutral-800 text-[15px]">
                                {badge.title[language] || badge.title.en}
                            </h3>
                            <p className="text-[13px] text-neutral-600 mt-1 leading-relaxed">
                                {badge.desc[language] || badge.desc.en}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </Modal>
    );
}
